<mat-nav-list>
    <a mat-list-item (click)="selecionaRelatorio('FM')">
        <span mat-line>Ficha Matrícula</span>
    </a>

    <a mat-list-item (click)="selecionaRelatorio('PE')">
        <span mat-line>Passe Estudantil</span>
    </a>
</mat-nav-list>